import Vue from 'vue'
import {CONSTANTS_PROD, CONSTANTS_TEST, TEST_ENVIRONMENT} from '../../config/constants'
import axios from 'axios'
import {bus} from '../../components/Restaurant/bus-restaurant'
import _ from "lodash";

export var restaurant_service = new Vue({

    data() {
        return {
            constants: {},
            full_url: ''
        }
    },
    methods: {
        async GetAllRestaurant() {
            console.log("get all restaurant")
            await axios.get(this.full_url + 'search/restaurant_index')
                .then(function (response) {

                    bus.GetAllRestaurant(_.map(response.data.body.hits.hits, "_source"), response.data.body.hits.total)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllDiscounts() {
            await axios.get(this.full_url + 'discounts')
                .then(function (response) {
                    bus.GetAllDiscounts(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllDealer() {
            await axios({
                method: 'POST',
                url: this.full_url + 'users/filter/2',
                data: {
                    from: 0,
                    size: 10000
                }
            })
                .then(function (response) {
                    bus.GetAllDealer(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllrestaurantFull() {
            await axios({
                method: 'POST',
                url: this.full_url + 'search/restaurant_index',
                data: {
                    from: 0,
                    size: 10000
                }
            })
                .then(function (response) {

                    bus.GetAllrestaurantFull(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllrestaurantPagination(page) {
            await axios({
                method: 'POST',
                url: this.full_url + 'search/restaurant_index',
                data: {
                    from: page,
                    size: 10
                }
            })
                .then(function (response) {

                    bus.GetAllrestaurantPagination(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllRestaurantSearch(data) {
            await axios.get(this.full_url + 'search/restaurant_index/' + data)
                .then(function (response) {
                    bus.GetAllRestaurant(_.map(response.data.body.hits.hits, "_source"), response.data.body.hits.total)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllSedes() {

            await axios.get(this.full_url + 'restaurant/child/1')
                .then(function (response) {
                    console.log(response)
                    bus.GetAllSedes(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllCountry() {

            await axios({
                method: 'post',
                url: this.full_url + 'locate',
                data: {
                    "name": "country",
                    "param": "1"
                }
            })
                .then(function (response) {
                    bus.GetAllCountry(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllState() {

            await axios({
                method: 'post',
                url: this.full_url + 'locate',
                data: {
                    "name": "state",
                    "param": "3"
                }
            })
                .then(function (response) {

                    bus.GetAllState(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllCity() {

            await axios({
                method: 'post',
                url: this.full_url + 'locate',
                data: {
                    "name": "city",
                    "param": "2"
                }
            })
                .then(function (response) {
                    bus.GetAllCity(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async CreateRestaurant(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'restaurant',
                data: data
            })
                .then(function (response) {
                    bus.ResponseCreateRestaurant(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async UpdateRestaurant(data) {
            await axios({
                method: 'PUT',
                url: this.full_url + 'restaurant',
                data: data
            })
                .then(function (response) {
                    bus.ResponseUpdateRestaurant(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async DeleteRestaurant(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'restaurant/deleteat',
                data: data
            })
                .then(function (response) {
                    bus.DeleteRestaurant(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        }
    },
    created() {
        (TEST_ENVIRONMENT) ? this.constans = CONSTANTS_TEST : this.constans = CONSTANTS_PROD;
        this.full_url = this.constans.URL_API + this.constans.VERSION_API;
    }

});
